import { SVGProps } from 'react';
import { BaseContainerComponentPropsType } from '../../util/types';
import AvatarArtwork, { type RenderShadowFn } from '../AvatarArtwork';
import { avatarDefaultBackgroundColors } from '../../config/avatarColors';

const renderShadow: RenderShadowFn = ({ style }) => (
  <path
    style={style}
    d="M47.7,25.8c-0.83,10.51-8.46,19.11-18.49,21.39c-2.69-3.53-6.56-9.01-12.16-17.51L31.25,9.3L47.7,25.8z"
  />
);

const LegolasAvatarArtwork = (
  props: {
    backgroundColor?: string;
  } & BaseContainerComponentPropsType &
    SVGProps<SVGSVGElement>,
) => (
  <AvatarArtwork
    {...props}
    defaultBackgroundColor={avatarDefaultBackgroundColors.legolas}
    renderShadow={renderShadow}
  >
    <>
      <g>
        <path
          style={{ fill: '#F2C56B' }}
          d="M31.92,25.11c-0.12,1.24-0.05,2.5,0.21,3.72c0.16,0.76,0.39,1.52,0.37,2.29c-0.02,1.09-0.53,2.12-1.16,3.02
		c-0.63,0.89-1.39,1.7-2,2.6c-0.61,0.91-1.09,1.96-1.05,3.05s0.69,2.22,1.74,2.54c-0.45-0.51-0.76-1.15-0.86-1.83
		c-0.05-0.32-0.05-0.65,0.05-0.96c0.09-0.29,0.28-0.55,0.47-0.79c1.12-1.38,2.73-2.35,3.61-3.88c1.14-1.98,0.85-4.48,0.06-6.62
		c-0.44-1.18-1.02-2.37-0.91-3.63c-0.18,0.19-0.36,0.38-0.55,0.56"
        />
        <g>
          <path
            style={{ fill: '#DDAF5E' }}
            d="M31.65,25.11c-0.07,0.92-0.07,1.83,0.05,2.75c0.12,0.98,0.48,1.94,0.53,2.93c0.1,2.03-1.38,3.54-2.54,5.03
			c-0.91,1.17-1.78,2.56-1.66,4.1c0.09,1.2,0.79,2.24,1.92,2.66c0.27,0.1,0.4-0.26,0.25-0.44c-0.86-1.05-1.08-2.34-0.15-3.42
			c0.49-0.57,1.06-1.06,1.61-1.57c1.04-0.96,1.97-1.99,2.39-3.37c0.39-1.32,0.32-2.75,0.02-4.08c-0.39-1.71-1.43-3.29-1.35-5.08
			c0.01-0.23-0.29-0.34-0.45-0.18c-0.18,0.19-0.36,0.38-0.55,0.56c-0.23,0.24,0.13,0.61,0.37,0.37c0.18-0.19,0.36-0.38,0.55-0.56
			c-0.15-0.06-0.3-0.12-0.45-0.18c-0.08,1.76,0.88,3.28,1.3,4.93c0.47,1.84,0.48,3.92-0.64,5.54c-0.94,1.35-2.38,2.24-3.39,3.53
			c-0.97,1.25-0.56,2.74,0.38,3.89c0.08-0.15,0.17-0.29,0.25-0.44c-2.01-0.75-1.72-3.19-0.85-4.7c0.75-1.3,1.87-2.33,2.65-3.61
			c0.63-1.03,0.98-2.17,0.82-3.38c-0.1-0.78-0.34-1.53-0.45-2.3c-0.15-0.99-0.16-1.98-0.08-2.98C32.2,24.77,31.68,24.78,31.65,25.11
			L31.65,25.11z"
          />
        </g>
      </g>
      <g>
        <path
          style={{ fill: '#F2C56B' }}
          d="M32.97,24.21c0.41,2.39,3,3.89,3.63,6.24c0.29,1.09,0.12,2.27-0.38,3.28c-0.37,0.76-0.91,1.42-1.34,2.14
		c-0.43,0.72-0.76,1.56-0.64,2.4c0.12,0.83,0.81,1.63,1.65,1.63c-0.71,0.06-1.5,0.1-2.04-0.36c-0.47-0.4-0.61-1.08-0.61-1.7
		c0-0.74,0.15-1.49,0.43-2.18c0.25-0.61,0.61-1.18,0.8-1.81c0.46-1.59-0.25-3.25-0.9-4.76s-1.26-3.25-0.61-4.77"
        />
        <g>
          <path
            style={{ fill: '#DDAF5E' }}
            d="M32.72,24.28c0.64,3.19,4.62,4.89,3.58,8.53c-0.49,1.7-2.08,2.91-2.31,4.71c-0.16,1.26,0.56,2.54,1.9,2.64
			c0-0.17,0-0.35,0-0.52c-0.9,0.07-1.92,0.1-2.27-0.94c-0.23-0.67-0.12-1.5,0.04-2.18c0.34-1.36,1.25-2.42,1.21-3.87
			c-0.08-2.83-2.75-5.39-1.66-8.27c0.12-0.32-0.39-0.45-0.5-0.14c-1.32,3.51,2.77,6.59,1.33,10.04c-0.59,1.4-1.33,2.76-0.97,4.34
			c0.32,1.43,1.56,1.65,2.84,1.55c0.33-0.03,0.34-0.5,0-0.52c-1.14-0.09-1.56-1.32-1.34-2.29c0.18-0.85,0.71-1.57,1.18-2.28
			c0.84-1.25,1.45-2.6,1.24-4.14c-0.37-2.71-3.21-4.15-3.74-6.78C33.16,23.81,32.66,23.95,32.72,24.28L32.72,24.28z"
          />
        </g>
      </g>
      <g>
        <path
          style={{ fill: '#F2C56B' }}
          d="M15.46,24.14c-0.69-0.24-1.46,0.17-1.92,0.75s-0.68,1.29-1.02,1.94c-0.33,0.65-0.83,1.29-1.54,1.47
		c-0.21,0.05-0.45,0.06-0.63-0.06c-0.18-0.12-0.28-0.38-0.16-0.56c-0.22,0.11-0.2,0.47-0.02,0.64c0.18,0.17,0.45,0.21,0.69,0.24
		c0.83,0.09,1.78,0.11,2.38-0.46c0.32-0.3,0.49-0.72,0.7-1.1c0.21-0.38,0.5-0.77,0.92-0.89c0.27-0.08,0.57-0.04,0.83-0.15
		c0.35-0.15,0.54-0.57,0.49-0.95c-0.05-0.38-0.3-0.71-0.62-0.92"
        />
        <g>
          <path
            style={{ fill: '#DDAF5E' }}
            d="M15.53,23.89c-1.28-0.4-2.26,0.74-2.75,1.77c-0.27,0.58-0.49,1.19-0.89,1.7c-0.19,0.24-0.41,0.45-0.68,0.59
			c-0.14,0.07-0.3,0.13-0.46,0.14c-0.12,0.01-0.44-0.06-0.33-0.26c0.11-0.22-0.13-0.51-0.36-0.36c-0.26,0.17-0.35,0.46-0.25,0.76
			c0.1,0.33,0.43,0.5,0.75,0.56c0.72,0.14,1.58,0.17,2.27-0.12c0.77-0.32,1.01-1.03,1.42-1.69c0.24-0.39,0.52-0.61,0.98-0.66
			c0.36-0.04,0.69-0.1,0.93-0.39c0.59-0.69,0.18-1.59-0.47-2.06c-0.27-0.2-0.53,0.26-0.26,0.45c0.29,0.21,0.54,0.54,0.49,0.91
			c-0.05,0.45-0.4,0.54-0.78,0.58c-0.72,0.08-1.14,0.54-1.47,1.15c-0.16,0.31-0.3,0.64-0.54,0.9c-0.25,0.27-0.61,0.41-0.97,0.47
			c-0.34,0.05-0.69,0.04-1.02,0.01c-0.19-0.02-0.39-0.02-0.57-0.08c-0.08-0.02-0.41-0.22-0.24-0.33c-0.12-0.12-0.24-0.24-0.36-0.36
			c-0.35,0.67,0.39,1.14,0.99,1.02c0.67-0.13,1.19-0.64,1.55-1.19c0.42-0.64,0.63-1.39,1.04-2.04c0.38-0.62,1.08-1.2,1.85-0.96
			C15.71,24.49,15.85,23.99,15.53,23.89L15.53,23.89z"
          />
        </g>
      </g>
      <g>
        <path
          style={{ fill: '#F2C56B' }}
          d="M15.97,25.65c0.12,1.24,0.05,2.5-0.21,3.72c-0.16,0.76-0.39,1.52-0.37,2.29c0.02,1.09,0.53,2.12,1.16,3.02
		c0.63,0.89,1.39,1.7,2,2.6c0.61,0.91,1.09,1.96,1.05,3.05c-0.04,1.09-0.69,2.22-1.74,2.54c0.45-0.51,0.76-1.15,0.86-1.83
		c0.05-0.32,0.05-0.65-0.05-0.96c-0.09-0.29-0.28-0.55-0.47-0.79c-1.12-1.38-2.73-2.35-3.61-3.88c-1.14-1.98-0.85-4.48-0.06-6.62
		c0.44-1.18,1.02-2.37,0.91-3.63c0.18,0.19,0.36,0.38,0.55,0.56"
        />
        <g>
          <path
            style={{ fill: '#DDAF5E' }}
            d="M15.71,25.65c0.07,0.9,0.07,1.78-0.04,2.68c-0.11,0.88-0.38,1.73-0.49,2.6c-0.16,1.21,0.19,2.35,0.82,3.38
			c0.78,1.28,1.9,2.31,2.65,3.61c0.86,1.5,1.17,3.94-0.85,4.7c0.08,0.15,0.17,0.29,0.25,0.44c0.88-1.07,1.36-2.56,0.47-3.77
			c-1.01-1.36-2.52-2.25-3.48-3.65c-1.08-1.59-1.11-3.59-0.68-5.4c0.41-1.71,1.42-3.27,1.34-5.07c-0.15,0.06-0.3,0.12-0.45,0.18
			c0.18,0.19,0.36,0.38,0.55,0.56c0.23,0.24,0.6-0.13,0.37-0.37c-0.18-0.19-0.36-0.38-0.55-0.56c-0.15-0.16-0.46-0.04-0.45,0.18
			c0.08,1.74-0.92,3.28-1.32,4.94c-0.33,1.38-0.42,2.85-0.02,4.22c0.4,1.33,1.28,2.35,2.28,3.28c0.55,0.51,1.12,1,1.62,1.56
			c0.98,1.11,0.86,2.4-0.06,3.52c-0.15,0.18-0.02,0.54,0.25,0.44c1.09-0.41,1.79-1.38,1.91-2.53c0.17-1.59-0.72-3.03-1.65-4.23
			c-1.11-1.43-2.57-2.91-2.54-4.86c0.02-1.03,0.4-2.04,0.53-3.06c0.12-0.93,0.13-1.85,0.05-2.78C16.2,25.31,15.68,25.31,15.71,25.65
			L15.71,25.65z"
          />
        </g>
      </g>
      <g>
        <path
          style={{ fill: '#F2C56B' }}
          d="M14.91,24.75c-0.41,2.39-3,3.89-3.63,6.24c-0.29,1.09-0.12,2.27,0.38,3.28c0.37,0.76,0.91,1.42,1.34,2.14
		c0.43,0.72,0.76,1.56,0.64,2.4s-0.81,1.63-1.65,1.63c0.71,0.06,1.5,0.1,2.04-0.36c0.47-0.4,0.61-1.08,0.61-1.7
		c0-0.74-0.15-1.49-0.43-2.18c-0.25-0.61-0.61-1.18-0.8-1.81c-0.46-1.59,0.25-3.25,0.9-4.76s1.26-3.25,0.61-4.77"
        />
        <g>
          <path
            style={{ fill: '#DDAF5E' }}
            d="M14.66,24.68c-0.53,2.63-3.37,4.07-3.74,6.78c-0.2,1.48,0.36,2.81,1.16,4.02c0.47,0.71,1.02,1.43,1.23,2.28
			c0.25,1-0.09,2.32-1.31,2.42c-0.34,0.03-0.34,0.49,0,0.52c1.22,0.1,2.45-0.08,2.81-1.43c0.42-1.6-0.35-3.03-0.94-4.45
			c-1.44-3.45,2.64-6.52,1.33-10.04c-0.12-0.31-0.62-0.18-0.5,0.14c1.08,2.88-1.59,5.44-1.66,8.27c-0.04,1.41,0.81,2.43,1.17,3.74
			c0.2,0.71,0.32,1.59,0.08,2.31c-0.35,1.04-1.38,1.01-2.27,0.94c0,0.17,0,0.35,0,0.52c1.34-0.1,2.06-1.38,1.9-2.64
			c-0.23-1.8-1.82-3-2.31-4.71c-1.05-3.63,2.94-5.34,3.58-8.53C15.23,24.49,14.72,24.35,14.66,24.68L14.66,24.68z"
          />
        </g>
      </g>
      <g>
        <path
          style={{ fill: '#F2C56B' }}
          d="M32.77,23.9c0.69-0.24,1.46,0.17,1.92,0.75s0.68,1.29,1.02,1.94c0.33,0.65,0.83,1.29,1.54,1.47
		c0.21,0.05,0.45,0.06,0.63-0.06s0.28-0.38,0.16-0.56c0.22,0.11,0.2,0.47,0.02,0.64c-0.18,0.17-0.45,0.21-0.69,0.24
		c-0.83,0.09-1.78,0.11-2.38-0.46c-0.32-0.3-0.49-0.72-0.7-1.1c-0.21-0.38-0.5-0.77-0.92-0.89c-0.27-0.08-0.57-0.04-0.83-0.15
		c-0.35-0.15-0.54-0.57-0.49-0.95c0.05-0.38,0.3-0.71,0.62-0.92"
        />
        <g>
          <path
            style={{ fill: '#DDAF5E' }}
            d="M32.83,24.15c0.77-0.24,1.47,0.34,1.85,0.96c0.4,0.65,0.62,1.4,1.04,2.04c0.36,0.55,0.88,1.06,1.55,1.19
			c0.6,0.11,1.35-0.35,0.99-1.02c-0.12,0.12-0.24,0.24-0.36,0.36c0.18,0.12-0.16,0.31-0.24,0.33c-0.17,0.06-0.35,0.06-0.53,0.08
			c-0.35,0.03-0.72,0.05-1.07-0.01c-0.35-0.06-0.68-0.18-0.94-0.44c-0.26-0.26-0.41-0.61-0.58-0.93c-0.32-0.61-0.75-1.07-1.47-1.15
			c-0.37-0.04-0.7-0.11-0.78-0.53c-0.07-0.39,0.19-0.74,0.49-0.96c0.27-0.2,0.01-0.65-0.26-0.45c-0.57,0.41-0.96,1.11-0.64,1.8
			c0.15,0.33,0.44,0.54,0.79,0.61c0.43,0.08,0.78,0.07,1.09,0.43c0.51,0.59,0.64,1.41,1.35,1.83c0.65,0.39,1.46,0.37,2.19,0.29
			c0.38-0.04,0.84-0.11,1.04-0.48c0.17-0.31,0.1-0.69-0.2-0.89c-0.23-0.15-0.47,0.14-0.36,0.36c0.09,0.17-0.16,0.26-0.29,0.26
			c-0.16,0.01-0.33-0.05-0.47-0.12c-0.27-0.13-0.49-0.33-0.68-0.56c-0.42-0.51-0.65-1.15-0.93-1.74c-0.49-1.03-1.47-2.17-2.75-1.77
			C32.38,23.74,32.51,24.25,32.83,24.15L32.83,24.15z"
          />
        </g>
      </g>
      <g>
        <path
          style={{ fill: '#F7DEBC' }}
          d="M31.62,21.09c0.02-0.69,0.63-1.24,1.27-1.5c0.64-0.26,1.35-0.34,2-0.59c0.57-0.22,1.07-0.57,1.55-0.94
		c-0.13,0.96-0.27,1.96-0.78,2.79c-0.22,0.37-0.51,0.69-0.8,1.01c-0.27,0.31-0.55,0.61-0.82,0.92c-0.73,0.81-1.62,1.7-2.71,1.61
		c-0.36-0.03-0.74-0.2-0.88-0.53c-0.1-0.24-0.07-0.5-0.03-0.76c0.11-0.7,0.23-1.41,0.53-2.06c0.3-0.65,0.79-1.23,1.45-1.5"
        />
        <g>
          <path
            style={{ fill: '#F7DEBC' }}
            d="M31.99,21.09c0.06-0.95,1.24-1.26,1.99-1.44c0.47-0.12,0.94-0.24,1.38-0.46c0.45-0.22,0.86-0.51,1.26-0.81
			c-0.18-0.14-0.37-0.28-0.55-0.42c-0.16,1.17-0.35,2.3-1.13,3.23c-0.4,0.48-0.82,0.93-1.24,1.4c-0.35,0.39-0.72,0.78-1.16,1.07
			c-0.4,0.26-0.91,0.47-1.39,0.32c-0.64-0.19-0.36-0.97-0.26-1.45c0.21-1.08,0.62-2.2,1.7-2.67c0.44-0.19,0.06-0.83-0.38-0.64
			c-0.97,0.42-1.56,1.37-1.86,2.35c-0.16,0.53-0.26,1.09-0.33,1.64c-0.07,0.54,0.07,1.03,0.55,1.33c0.88,0.55,1.97,0.08,2.7-0.49
			c0.41-0.32,0.76-0.7,1.1-1.09c0.39-0.44,0.79-0.86,1.16-1.31c0.83-1.02,1.08-2.2,1.25-3.47c0.04-0.27-0.25-0.65-0.55-0.42
			c-0.45,0.35-0.93,0.69-1.46,0.9c-0.54,0.22-1.12,0.29-1.67,0.47c-0.92,0.3-1.8,0.94-1.87,1.98
			C31.21,21.57,31.96,21.57,31.99,21.09L31.99,21.09z"
          />
        </g>
      </g>
      <g>
        <path
          style={{ fill: '#F7DEBC' }}
          d="M16.09,21.27c0.03-0.69-0.53-1.28-1.15-1.6s-1.32-0.44-1.95-0.74c-0.55-0.26-1.02-0.65-1.48-1.05
		c0.06,0.97,0.12,1.97,0.56,2.84c0.2,0.38,0.46,0.73,0.72,1.07c0.25,0.33,0.5,0.65,0.75,0.98c0.66,0.87,1.49,1.81,2.58,1.81
		c0.36,0,0.75-0.15,0.92-0.47c0.12-0.23,0.1-0.5,0.08-0.75c-0.06-0.71-0.13-1.43-0.37-2.09c-0.25-0.67-0.7-1.29-1.33-1.6"
        />
        <g>
          <path
            style={{ fill: '#F7DEBC' }}
            d="M16.46,21.27c0.01-1.04-0.85-1.74-1.74-2.1c-0.51-0.2-1.05-0.32-1.54-0.56c-0.52-0.25-0.97-0.61-1.4-1
			c-0.22-0.2-0.66-0.08-0.64,0.26c0.07,1.15,0.17,2.33,0.79,3.33c0.32,0.51,0.71,0.97,1.07,1.45c0.31,0.41,0.62,0.82,0.97,1.19
			c0.65,0.68,1.58,1.29,2.57,1.04c0.45-0.11,0.83-0.43,0.94-0.89c0.12-0.53-0.01-1.16-0.09-1.69c-0.17-1.18-0.67-2.39-1.78-2.97
			c-0.43-0.22-0.8,0.42-0.38,0.64c1.03,0.54,1.35,1.71,1.47,2.78c0.05,0.46,0.27,1.23-0.31,1.4c-0.47,0.14-0.99-0.09-1.37-0.37
			c-0.41-0.3-0.74-0.7-1.06-1.09c-0.37-0.47-0.74-0.95-1.09-1.43c-0.36-0.49-0.63-0.99-0.77-1.58c-0.14-0.59-0.18-1.21-0.22-1.81
			c-0.21,0.09-0.42,0.18-0.64,0.26c0.36,0.32,0.74,0.64,1.15,0.89c0.42,0.26,0.88,0.43,1.35,0.58c0.78,0.26,1.97,0.63,1.96,1.65
			C15.71,21.75,16.46,21.75,16.46,21.27L16.46,21.27z"
          />
        </g>
      </g>
      <path
        style={{ fill: '#F7DEBC' }}
        d="M32.41,14.05l-0.61,13.12c-0.05,1.02-0.53,1.95-1.35,2.5l-4.26,2.39c-1.76,1.2-3.12,1.2-4.87,0l-4.26-2.39
	c-0.81-0.56-1.3-1.49-1.35-2.5l-0.61-13.12c-0.07-1.49,0.2-2.9,1.43-3.64l4.36-2.65c1.76-1.07,3.92-1.07,5.68-0.01l4.4,2.66
	C32.2,11.15,32.48,12.56,32.41,14.05z"
      />
      <g>
        <path
          style={{ fill: '#F2C56B' }}
          d="M15.05,20.73c-0.38-2.67-0.74-5.48,0.06-8.02c0.63-1.99,1.97-3.62,3.56-4.63s3.43-1.43,5.25-1.4
		c2.08,0.04,4.16,0.66,6,1.8c0.87,0.54,1.71,1.21,2.26,2.16c0.9,1.55,0.92,3.56,0.9,5.44c-0.01,1.3-0.02,2.61-0.32,3.86
		c-0.29,1.25-0.91,2.45-1.87,3.11c-0.01-0.98,1.04-2.28,1.03-3.26c-0.01-1.12,0.08-2.14-0.19-3.22c-0.2-0.81-1.1-1.56-1.66-2.1
		c-0.56-0.53-1.24-0.85-1.94-0.61c-0.67,0.23-1.88,1.13-2.53,1.45c-0.45,0.22-0.95,0.27-1.44,0.32c-1.23,0.12-2.64-0.64-3.7-1.38
		c-0.61-0.42-1.11-0.28-1.81-0.12c-0.7,0.17-1.74,0.78-2.16,1.46c-1.46,2.4-0.6,5.32,0.1,7.79c-0.53-0.03-0.98-0.51-1.22-1.06
		c-0.24-0.56-0.3-1.19-0.37-1.81"
        />
        <g>
          <path
            style={{ fill: '#DDAF5E' }}
            d="M15.3,20.67c-0.48-3.38-0.91-7.08,1.14-10.06c2-2.91,5.56-4.07,8.97-3.54c1.64,0.25,3.23,0.87,4.61,1.79
			c1.64,1.08,2.49,2.59,2.71,4.53c0.17,1.52,0.14,3.12,0.04,4.64c-0.11,1.74-0.52,3.7-2,4.79c0.13,0.08,0.26,0.15,0.39,0.23
			c0.07-1.09,0.89-1.97,1.02-3.05c0.13-1.13,0.15-2.64-0.26-3.72c-0.33-0.86-1.17-1.62-1.88-2.18c-0.66-0.53-1.41-0.73-2.2-0.4
			c-1,0.42-1.8,1.28-2.86,1.55c-1.52,0.39-2.89-0.27-4.14-1.07c-1.64-1.04-3.95,0.02-4.77,1.67c-1.2,2.41-0.4,5.17,0.29,7.6
			c0.11-0.11,0.21-0.21,0.32-0.32c-1.17-0.21-1.3-1.67-1.4-2.62c-0.03-0.33-0.56-0.33-0.52,0c0.12,1.19,0.35,2.86,1.78,3.12
			c0.19,0.03,0.38-0.12,0.32-0.32c-0.67-2.38-1.85-6.08,0.29-8.08c0.52-0.48,1.19-0.78,1.87-0.93c0.92-0.2,1.41,0.26,2.17,0.7
			c1.02,0.58,2.09,0.97,3.27,0.84c1.04-0.11,1.77-0.61,2.64-1.15c0.68-0.42,1.33-0.89,2.16-0.5c0.54,0.25,1.1,0.86,1.5,1.3
			c1.04,1.14,1.01,2.82,0.9,4.28c-0.08,1.16-0.96,2.09-1.03,3.26c-0.01,0.19,0.24,0.34,0.39,0.23c2.3-1.71,2.3-4.9,2.32-7.49
			c0.01-2.78-0.31-5.4-2.71-7.14c-4.61-3.33-11.83-3.06-14.94,2.16c-1.81,3.04-1.36,6.66-0.89,10
			C14.84,21.14,15.35,20.99,15.3,20.67L15.3,20.67z"
          />
        </g>
      </g>
      <g>
        <path
          style={{ fill: '#F2C56B' }}
          d="M32.64,18.84c0.57-0.01,1.14-0.19,1.55-0.58s0.63-1,0.47-1.54c-0.03-0.1-0.07-0.19-0.13-0.27
		c-0.13-0.15-0.34-0.2-0.54-0.2c-0.51,0-1.01,0.33-1.22,0.8s-0.12,1.05,0.22,1.44"
        />
        <g>
          <path
            style={{ fill: '#F2C56B' }}
            d="M32.64,19.21c0.63-0.02,1.24-0.21,1.72-0.61c0.45-0.38,0.75-0.98,0.72-1.58c-0.01-0.32-0.1-0.67-0.35-0.89
			c-0.23-0.21-0.56-0.28-0.87-0.25c-0.58,0.05-1.15,0.4-1.41,0.94c-0.31,0.64-0.2,1.39,0.26,1.92c0.13,0.15,0.39,0.13,0.53,0
			c0.15-0.15,0.13-0.37,0-0.53c-0.05-0.06-0.02-0.03-0.01-0.01c-0.02-0.02-0.03-0.04-0.04-0.06c-0.03-0.04-0.05-0.09-0.07-0.13
			c0-0.01-0.03-0.06-0.01-0.02c-0.01-0.02-0.02-0.05-0.03-0.07c-0.02-0.05-0.03-0.11-0.04-0.17c0-0.01-0.01-0.09-0.01-0.05
			c0,0.04,0-0.03,0-0.03c0-0.05,0-0.1,0-0.15c0-0.03,0-0.05,0.01-0.08c-0.01,0.06,0,0,0-0.01c0.01-0.06,0.02-0.11,0.04-0.17
			c0-0.01,0.03-0.08,0.01-0.05c-0.01,0.04,0.02-0.03,0.02-0.04c0.02-0.04,0.05-0.09,0.07-0.13c0-0.01,0.05-0.07,0.03-0.04
			c-0.02,0.03,0.02-0.03,0.03-0.03c0.04-0.04,0.08-0.08,0.12-0.12c0.02-0.02,0.04-0.03,0.06-0.05c-0.02,0.01-0.04,0.03,0.02-0.01
			c0.04-0.03,0.08-0.05,0.13-0.08c0.02-0.01,0.03-0.02,0.05-0.03c0.06-0.03-0.04,0.02,0.01-0.01c0.05-0.02,0.11-0.04,0.16-0.05
			c0.01,0,0.15-0.02,0.08-0.02c0.05,0,0.1-0.01,0.15-0.01c0.03,0,0.05,0,0.08,0c-0.02,0-0.05-0.02,0.01,0
			c0.02,0.01,0.05,0.01,0.07,0.02c-0.05-0.01,0.01,0.01,0.03,0.02c0.05,0.03-0.03-0.03,0.01,0.01c0.01,0.01,0.03,0.02,0.04,0.04
			c-0.02-0.03,0.01,0.03,0.01,0.03c-0.01-0.03,0.01,0.03,0.01,0.03c0.02,0.05,0.03,0.1,0.04,0.16c0.02,0.07,0.01,0.03,0,0.02
			c0,0.03,0.01,0.06,0.01,0.1c0,0.17-0.03,0.38-0.1,0.52c-0.1,0.21-0.18,0.31-0.34,0.46c-0.14,0.12-0.37,0.25-0.54,0.31
			c-0.12,0.04-0.25,0.08-0.38,0.1c-0.01,0-0.09,0.02-0.05,0.01c0.02,0-0.07,0.01-0.07,0.01c-0.07,0.01-0.14,0.01-0.21,0.01
			c-0.2,0.01-0.37,0.17-0.37,0.37C32.26,19.03,32.44,19.22,32.64,19.21L32.64,19.21z"
          />
        </g>
      </g>
      <g>
        <path
          style={{ fill: '#F2C56B' }}
          d="M15.24,18.79c-0.57-0.01-1.14-0.19-1.55-0.58s-0.63-1-0.47-1.54c0.03-0.1,0.07-0.19,0.13-0.27
		c0.13-0.15,0.34-0.2,0.54-0.2c0.51,0,1.01,0.33,1.22,0.8s0.12,1.05-0.22,1.44"
        />
        <g>
          <path
            style={{ fill: '#F2C56B' }}
            d="M15.24,18.42c-0.41-0.01-0.8-0.11-1.16-0.36c-0.14-0.1-0.28-0.25-0.37-0.41c-0.03-0.05-0.05-0.09-0.07-0.14
			c0,0-0.03-0.07-0.01-0.02c-0.01-0.02-0.02-0.05-0.03-0.07c-0.01-0.04-0.03-0.09-0.04-0.13c-0.01-0.03-0.01-0.05-0.02-0.08
			c0-0.02-0.01-0.09-0.01-0.04c0-0.05-0.01-0.1-0.01-0.16c0-0.03,0-0.05,0-0.08c0-0.01,0.01-0.07,0-0.02
			c0.01-0.05,0.02-0.1,0.03-0.15c0.01-0.05,0.03-0.09,0.04-0.11c0,0,0.08-0.06,0.03-0.03c0.02-0.01,0.04-0.03,0.06-0.03
			c-0.05,0.02,0.01,0,0.02,0c0.02,0,0.05-0.01,0.07-0.02c-0.06,0.01,0,0,0.01,0c0.06,0,0.11,0,0.17,0c0.06,0-0.05-0.01,0.01,0
			c0.02,0,0.05,0.01,0.07,0.01c0.05,0.01,0.1,0.03,0.14,0.04c0.01,0,0.08,0.03,0.04,0.02c-0.03-0.01,0.02,0.01,0.02,0.01
			c0.06,0.03,0.11,0.06,0.16,0.09c0.01,0,0.06,0.04,0.02,0.01c0.02,0.01,0.04,0.03,0.06,0.05c0.03,0.03,0.06,0.06,0.09,0.09
			c0.02,0.02,0.03,0.04,0.05,0.06c0.04,0.05-0.03-0.04,0.01,0.01c0.03,0.05,0.06,0.09,0.09,0.14c0.01,0.02,0.02,0.04,0.03,0.07
			c-0.02-0.05,0.01,0.03,0.01,0.04c0.02,0.05,0.03,0.11,0.04,0.17c0.02,0.08,0,0.03,0,0.01c0,0.04,0.01,0.08,0.01,0.11
			c0,0.05,0,0.1-0.01,0.15c0.01-0.06,0,0,0,0.01c-0.01,0.04-0.02,0.08-0.02,0.11c-0.01,0.02-0.01,0.05-0.02,0.07
			c0,0.01-0.03,0.09-0.02,0.06c0.01-0.04-0.02,0.04-0.02,0.04c-0.01,0.03-0.03,0.06-0.05,0.08c-0.01,0.02-0.03,0.04-0.04,0.06
			c-0.04,0.06,0.01-0.01-0.04,0.05c-0.13,0.15-0.15,0.38,0,0.53c0.13,0.13,0.4,0.15,0.53,0c0.39-0.46,0.56-1.11,0.36-1.69
			c-0.19-0.56-0.68-1.01-1.26-1.13c-0.3-0.07-0.63-0.06-0.91,0.08c-0.3,0.15-0.46,0.45-0.52,0.77c-0.11,0.62,0.11,1.25,0.55,1.7
			c0.48,0.5,1.19,0.73,1.87,0.75c0.2,0.01,0.37-0.18,0.37-0.37C15.62,18.59,15.45,18.43,15.24,18.42L15.24,18.42z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#DDAF5E' }}
            d="M32.13,17.48c0.55-0.53,1.27-0.89,2.03-0.99c0.12-0.02,0.22-0.09,0.22-0.22c0-0.11-0.1-0.24-0.22-0.22
			c-0.88,0.12-1.7,0.5-2.35,1.12C31.61,17.36,31.93,17.68,32.13,17.48L32.13,17.48z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#DDAF5E' }}
            d="M32.16,18.7c0.53-0.37,1.13-0.64,1.7-0.96c0.39-0.22,0.99-0.53,1.03-1.04c0.02-0.29-0.42-0.29-0.45,0
			c0-0.06,0-0.01,0,0.01c0,0.01-0.01,0.02-0.01,0.03c0.01-0.02,0.01-0.03,0-0.01c-0.01,0.02-0.02,0.03-0.03,0.05
			c0,0.01-0.05,0.06-0.02,0.03c-0.06,0.08-0.14,0.14-0.21,0.2c-0.2,0.15-0.44,0.29-0.66,0.41c-0.53,0.29-1.08,0.54-1.57,0.89
			C31.7,18.48,31.92,18.87,32.16,18.7L32.16,18.7z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#DDAF5E' }}
            d="M32.12,19.26c0.67-0.06,1.35-0.23,1.89-0.64c0.5-0.38,0.85-0.91,0.94-1.54c0.02-0.12-0.11-0.22-0.22-0.22
			c-0.13,0-0.21,0.1-0.22,0.22c-0.06,0.48-0.39,0.92-0.78,1.2c-0.47,0.33-1.04,0.48-1.6,0.53C32,18.82,31.9,18.9,31.9,19.03
			C31.9,19.15,32,19.27,32.12,19.26L32.12,19.26z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#DDAF5E' }}
            d="M16.09,17.95c0.06-0.55-0.22-1.11-0.63-1.47c-0.44-0.39-1.01-0.6-1.58-0.73c-0.28-0.07-0.4,0.37-0.12,0.43
			c0.48,0.11,0.98,0.27,1.36,0.59c0.34,0.29,0.57,0.71,0.52,1.17c-0.01,0.12,0.11,0.22,0.22,0.22
			C15.99,18.18,16.07,18.07,16.09,17.95L16.09,17.95z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#DDAF5E' }}
            d="M15.66,18.74c-0.88,0.19-1.87-0.34-2.19-1.19c-0.04-0.11-0.15-0.19-0.28-0.16c-0.11,0.03-0.2,0.16-0.16,0.28
			c0.41,1.08,1.61,1.74,2.75,1.5C16.06,19.11,15.94,18.68,15.66,18.74L15.66,18.74z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#DDAF5E' }}
            d="M15.72,18.03c-0.53,0.02-0.99-0.12-1.39-0.48c-0.41-0.37-0.74-0.81-1.14-1.19c-0.21-0.2-0.52,0.12-0.32,0.32
			c0.42,0.4,0.76,0.88,1.21,1.26c0.47,0.39,1.02,0.57,1.64,0.55C16,18.46,16,18.02,15.72,18.03L15.72,18.03z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#DDAF5E' }}
            d="M18.58,14c-1.23-0.66-2.78-0.96-3.95-0.01c-0.22,0.18,0.09,0.5,0.32,0.32c1-0.81,2.38-0.47,3.4,0.08
			C18.61,14.53,18.84,14.14,18.58,14L18.58,14z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#DDAF5E' }}
            d="M26.69,14.95c1.13-0.41,1.81-1.39,2.69-2.14c0.45-0.38,1.01-0.71,1.62-0.72c0.53-0.01,1.09,0.27,1.28,0.79
			c0.1,0.27,0.53,0.15,0.43-0.12c-0.43-1.21-1.86-1.33-2.87-0.81c-1.25,0.64-1.93,2.06-3.27,2.55
			C26.3,14.62,26.42,15.05,26.69,14.95L26.69,14.95z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#DDAF5E' }}
            d="M30.4,14.89c0.55-0.06,1.11-0.29,1.66-0.22c0.37,0.04,0.76,0.25,0.84,0.63c0.06,0.28,0.49,0.16,0.43-0.12
			c-0.1-0.51-0.58-0.84-1.07-0.93c-0.63-0.13-1.25,0.12-1.87,0.19c-0.12,0.01-0.22,0.09-0.22,0.22
			C30.18,14.77,30.28,14.9,30.4,14.89L30.4,14.89z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#DDAF5E' }}
            d="M25.26,15.33c-0.14-0.9,0.11-1.8,0.48-2.62c0.33-0.75,0.73-1.52,1.23-2.17c0.38-0.5,0.85-0.85,1.4-1.17
			c0.5-0.28,1.04-0.57,1.61-0.67c0.28-0.05,0.16-0.48-0.12-0.43C29.24,8.38,28.64,8.69,28.1,9c-0.61,0.35-1.11,0.76-1.54,1.33
			c-0.54,0.72-0.97,1.55-1.31,2.38c-0.37,0.88-0.57,1.79-0.42,2.74C24.87,15.73,25.3,15.61,25.26,15.33L25.26,15.33z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#DDAF5E' }}
            d="M23.73,15.52c0.13-1.49-0.05-3.01-0.35-4.47c-0.3-1.48-0.73-2.93-1.33-4.31c-0.11-0.26-0.5-0.04-0.39,0.23
			c0.58,1.35,0.99,2.77,1.28,4.2c0.29,1.43,0.46,2.9,0.33,4.35C23.25,15.81,23.7,15.81,23.73,15.52L23.73,15.52z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#DDAF5E' }}
            d="M22.32,15.11c0.09-0.63-0.16-1.18-0.55-1.66c-0.42-0.53-0.93-1-1.44-1.44c-0.5-0.43-1.03-0.81-1.64-1.06
			c-0.69-0.27-1.44-0.35-2.17-0.43c-0.29-0.03-0.28,0.42,0,0.45c0.64,0.07,1.29,0.14,1.91,0.36c0.56,0.2,1.07,0.55,1.52,0.93
			c0.42,0.36,0.83,0.75,1.21,1.15c0.4,0.42,0.83,0.96,0.74,1.57C21.85,15.27,22.28,15.39,22.32,15.11L22.32,15.11z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#DDAF5E' }}
            d="M13.81,15.8c-0.31-0.12-0.67,0.01-0.87,0.26c-0.24,0.29-0.28,0.69-0.24,1.05c0.09,0.74,0.54,1.46,1.3,1.65
			c0.28,0.07,0.4-0.36,0.12-0.43c-0.54-0.13-0.85-0.62-0.95-1.14c-0.05-0.23-0.06-0.51,0.05-0.73c0.09-0.18,0.28-0.3,0.48-0.22
			c0.11,0.04,0.25-0.05,0.28-0.16C14,15.95,13.92,15.85,13.81,15.8L13.81,15.8z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#DDAF5E' }}
            d="M13.43,17.68c0.01-0.31-0.04-0.63-0.15-0.93c-0.02-0.06-0.05-0.1-0.1-0.13c-0.05-0.03-0.12-0.04-0.17-0.02
			c-0.11,0.03-0.2,0.16-0.16,0.28c0.05,0.14,0.09,0.28,0.11,0.42c0,0.02,0.01,0.03,0.01,0.05c0.01,0.05-0.01-0.05,0,0.01
			c0,0.03,0.01,0.07,0.01,0.1c0.01,0.08,0.01,0.15,0,0.23c0,0.12,0.11,0.23,0.22,0.22C13.33,17.9,13.43,17.81,13.43,17.68
			L13.43,17.68z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#DDAF5E' }}
            d="M35.03,17.29c0.03-0.3,0-0.64-0.19-0.89c-0.11-0.14-0.26-0.24-0.44-0.29c-0.17-0.04-0.34-0.05-0.52-0.04
			c-0.12,0-0.23,0.1-0.22,0.22c0.01,0.12,0.1,0.23,0.22,0.22c0.07,0,0.14,0,0.21,0c0.03,0,0.08,0,0.11,0.01
			c-0.03,0-0.04-0.01-0.02,0c0.01,0,0.02,0,0.02,0c0.02,0,0.03,0.01,0.05,0.01c0.03,0.01,0.08,0.01,0.11,0.03
			c-0.03-0.01-0.03-0.01-0.02-0.01c0.01,0,0.01,0.01,0.02,0.01c0.01,0.01,0.03,0.02,0.04,0.02c0.01,0.01,0.02,0.01,0.03,0.02
			c-0.03-0.02-0.03-0.02-0.01-0.01c0.01,0.01,0.02,0.02,0.03,0.03c0.01,0.01,0.02,0.02,0.03,0.03c0.01,0.01,0.01,0.01,0.02,0.02
			c-0.02-0.03-0.02-0.03-0.01-0.02c0.02,0.02,0.03,0.05,0.05,0.07c0.01,0.01,0.01,0.03,0.02,0.04c-0.03-0.06-0.01-0.01,0,0
			c0.02,0.06,0.03,0.12,0.04,0.18c0,0.02,0,0.01,0-0.02c0,0.01,0,0.02,0,0.03c0,0.01,0,0.03,0,0.04c0,0.03,0,0.06,0,0.09
			c0,0.06,0,0.13-0.01,0.19c-0.01,0.12,0.11,0.23,0.22,0.22C34.94,17.51,35.02,17.42,35.03,17.29L35.03,17.29z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#DDAF5E' }}
            d="M33.86,18.87c0.34-0.24,0.68-0.49,0.9-0.85c0.21-0.35,0.31-0.77,0.26-1.17c-0.03-0.23-0.09-0.45-0.27-0.61
			c-0.15-0.13-0.33-0.23-0.53-0.27c-0.4-0.09-0.8,0.01-1.12,0.27c-0.11,0.09-0.09,0.28,0,0.37c0.11,0.11,0.26,0.09,0.37,0
			c0.18-0.15,0.44-0.19,0.66-0.13c0.11,0.03,0.23,0.09,0.3,0.18c0.08,0.1,0.08,0.26,0.08,0.38c0,0.28-0.09,0.55-0.24,0.79
			c-0.17,0.25-0.43,0.43-0.68,0.6c-0.12,0.08-0.17,0.23-0.09,0.36C33.57,18.89,33.74,18.95,33.86,18.87L33.86,18.87z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#DDAF5E' }}
            d="M33.52,15.94c-0.05-1.82-0.13-3.71-0.99-5.36c-0.8-1.54-2.32-2.5-3.86-3.2c-3.17-1.46-7.01-1.68-10.08,0.15
			c-0.29,0.17-0.03,0.62,0.26,0.45c2.9-1.73,6.55-1.53,9.55-0.15c1.42,0.65,2.85,1.51,3.62,2.92c0.86,1.58,0.92,3.43,0.97,5.19
			C33.01,16.27,33.53,16.27,33.52,15.94L33.52,15.94z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#DDAF5E' }}
            d="M14.8,15.84c-0.51-3.28,1.63-6.14,4.14-7.98c0.27-0.2,0.01-0.65-0.26-0.45c-2.72,2-4.93,5.03-4.38,8.57
			C14.35,16.31,14.86,16.17,14.8,15.84L14.8,15.84z"
          />
        </g>
      </g>
      <g>
        <path
          style={{ fill: '#E2AC91' }}
          d="M21.44,29.28c0.78,0.52,1.64,1.01,2.58,1.05c0.97,0.04,1.94-0.45,2.49-1.25c-0.33,0.15-0.7,0.16-1.07,0.16
		c-1.28,0.01-2.56,0.03-3.84,0.04"
        />
        <g>
          <path
            style={{ fill: '#E2AC91' }}
            d="M21.37,29.41c0.87,0.58,1.87,1.14,2.96,1.06c0.93-0.07,1.78-0.56,2.32-1.32c0.07-0.1-0.05-0.27-0.17-0.22
			c-0.36,0.15-0.74,0.15-1.13,0.16c-0.42,0-0.84,0.01-1.26,0.01c-0.83,0.01-1.65,0.02-2.48,0.03c-0.19,0-0.19,0.3,0,0.3
			c0.86-0.01,1.72-0.02,2.58-0.03c0.42,0,0.84-0.01,1.26-0.01c0.38-0.01,0.75-0.02,1.11-0.17c-0.06-0.07-0.11-0.15-0.17-0.22
			c-0.5,0.71-1.34,1.16-2.21,1.18c-0.98,0.02-1.86-0.5-2.65-1.03C21.36,29.05,21.21,29.3,21.37,29.41L21.37,29.41z"
          />
        </g>
      </g>
      <g>
        <path
          style={{ fill: '#D3916C' }}
          d="M21.37,29.11c1.13-0.55,2.42-0.62,3.67-0.61c0.58,0,1.21,0.04,1.66,0.42c-1.29,0.3-2.6,0.45-3.92,0.47
		c-0.42,0-0.84-0.01-1.23-0.16"
        />
        <g>
          <path
            style={{ fill: '#D3916C' }}
            d="M21.44,29.24c0.83-0.39,1.74-0.53,2.65-0.57c0.78-0.03,1.84-0.16,2.5,0.36c0.02-0.08,0.04-0.17,0.07-0.25
			c-0.85,0.19-1.7,0.33-2.57,0.4c-0.8,0.07-1.74,0.19-2.5-0.09c-0.18-0.07-0.26,0.22-0.08,0.29c0.8,0.3,1.76,0.17,2.58,0.1
			c0.89-0.07,1.77-0.21,2.64-0.41c0.1-0.02,0.15-0.18,0.07-0.25c-0.72-0.57-1.75-0.49-2.61-0.45c-1,0.04-1.99,0.19-2.9,0.62
			C21.12,29.06,21.27,29.32,21.44,29.24L21.44,29.24z"
          />
        </g>
      </g>
    </>
  </AvatarArtwork>
);

export default LegolasAvatarArtwork;
